import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getMyExpenseNotes = () => {
    return request({
        url: namespace + "/expense-notes",
        method: "get",
    });
};

export const getExpenseNotesToValidate = () => {
    return request({
        url: namespace + "/expense-notes/to-validate",
        method: "get",
    });
};

export const getExpenseNote = (id) => {
    return request({
        url: namespace + "/expense-notes/" + id,
        method: "get",
    });
};

export const createExpenseNote = (formData) => {
    return request({
        url: namespace + "/expense-notes",
        method: "post",
        data: formData,
    });
};

export const updateExpenseNote = (id, formData) => {
    return request({
        url: namespace + "/expense-notes/" + id,
        method: "put",
        data: formData,
    });
};

export const deleteExpenseNote = (id) => {
    return request({
        url: namespace + "/expense-notes/" + id,
        method: "delete",
    });
};

export const validateExpenseNote = (id) => {
    return request({
        url: namespace + "/expense-notes/" + id + "/validate",
        method: "post",
    });
};

export const refuseExpenseNote = (id, comment = null) => {
    return request({
        url: namespace + "/expense-notes/" + id + "/refuse",
        method: "post",
        data: comment ? { comment } : {},
    });
};

export const getAttachmentUrl = (noteId, filePath) => {
    const params = filePath ? `?path=${encodeURIComponent(filePath)}` : "";
    return request({
        url: namespace + "/expense-notes/" + noteId + "/attachment" + params,
        method: "get",
    });
};
